module.exports = __webpack_public_path__ + "static/media/hilda_for_now_by_corriger-dasn7aw.49cc0a9c.png";